(function () {
    'use strict';

    angular.module('app.access', [
        'utils',
        'components.auth',
        'app.core'
    ]);
})();